module.exports = __webpack_public_path__ + "assets/cef24ab7771f6e6f2c3153548678ef53.png";